import { styled } from '@mui/material/styles'

const ModalPage = styled('div')`
  padding: 0;

  @media (min-width: 769px) {
    padding: 1rem;
  }
`

export { ModalPage }
